export function maskPhone(tel: string) {
  const telNumber = tel.replace(/\D/g, '');

  tel = telNumber.replace(/^(\d)/, '($1')
  tel = tel.replace(/^(\(\d{2})(\d)/, '$1) $2')

  if (telNumber.length >= 11) {
    tel = tel.replace(/(\d{4,5})(\d{1,4})/, '$1-$2')
    tel = tel.replace(/(-\d{4})\d+?$/, '$1');
  } else {
    tel = tel.replace(/(\d{4})(\d{1,5})/, '$1-$2')
    tel = tel.replace(/(-\d{5})\d+?$/, '$1');
  }

  return tel;
}